const SubAbasSES = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/ses/ses/ficha/${id}/dadosgerais`,
  },
  /* {
    label: 'Usuário SES',
    rota: `/daf/ses/ses/ficha/${id}/usuarios`,
  },*/
  // {
  //   label: 'Histórico de Vínculos',
  //   rota: `/daf/ses/ses/ficha/${id}/vinculo`,
  // },
];

export default SubAbasSES;
